import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";
import '../../App.css';
import '../styles/MenuInfo.css';

export default function InfoPoliciesGuidelines() {
    const [data, setData] = useState([]);
    const [guidelines, setGuidelines] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/documentGuidelines.php');
            //console.log("API Response:", response.data);
            if (response.data.status === 'success' && response.data.data?.length) {
                setData(response.data.data); // Save all data
            } else {
                setError(response.data.message || 'No guidelines found');
            }
        } catch (error) {
            //console.error("Error fetching data:", error);
            setError('An error occurred while fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.title = "Policies & Guidelines"; // Set the tab name
        
        // Fetch guidelines from the backend
        // const fetchGuidelines = async () => {
        //     try {
        //         const response = await axios.get('http://localhost/api_drts/documentGuidelines.php');
        //         console.warn(response.data)
        //         if (response.data.status === 'success') {
        //             setGuidelines(response.data.guidelines);
        //         } else {
        //             setError('Failed to fetch guidelines');
        //         }
        //     } catch (err) {
        //         setError('An error occurred while fetching guidelines');
        //     } finally {
        //         setLoading(false);
        //     }
        // };

        // fetchGuidelines();

        fetchData();
    }, []);

    const navigate = useNavigate();
    const totalTopbarInfo = [
        { path: '', name: 'Document Protocol' },
        // { path: '', name: 'test' },
    ];

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
    

    return (
        <div className="viewport-container">
            {/* <section className='topbar'>
                {totalTopbarInfo.map((item, index) => (
                    // TODO do not use NavLink
                    <NavLink 
                        to={item.path} 
                        key={index} 
                        className='item_topbar' 
                        title={item.name} 
                        // activeClassName='active'
                    >
                        <div>{item.name}</div>
                    </NavLink>
                ))}              
            </section> */}

            {/* Main Content Section */}
            <section className="policies-content">
                <h2>Registrar Office CMS Guidelines & Policies</h2>
                {data.length > 0 ? (
                    <div className="policy-container">
                        {data.map((item, index) => (
                            <div key={index} className="policy-box">
                                <h3>{item.title}</h3>
                                <div className="policy-content">
                                    <p dangerouslySetInnerHTML={{ 
                                        __html: DOMPurify.sanitize(item.guidelines || "No guidelines available.") 
                                    }} />
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No guidelines available.</p>
                )}
            </section>
        </div>
    );
}